import { CustomCellEditorProps } from "ag-grid-react";
import { Select } from "antd";

type Props = CustomCellEditorProps & {
  enumOptions: { id: string; value: string }[];
};

function EnumDropdownCellEditor(props: Props) {
  const { stopEditing, value, enumOptions, onValueChange } = props;

  return (
    <div className="h-full flex items-end">
      <Select
        className="w-full"
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus
        allowClear
        showSearch
        filterOption
        optionFilterProp="label"
        value={value || undefined}
        options={enumOptions.map((opt) => ({
          label: opt.value,
          value: opt.id
        }))}
        onClear={() => {
          onValueChange(null);
          setTimeout(() => {
            stopEditing();
          }, 200);
        }}
        onChange={(val) => {
          onValueChange(val || null);
          setTimeout(() => {
            stopEditing();
          }, 200);
        }}
      />
    </div>
  );
}

export default EnumDropdownCellEditor;
